"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URL = 'content-settings/v1/site-maps';

var PagesForSitemapsAPI =
/*#__PURE__*/
function () {
  function PagesForSitemapsAPI() {
    (0, _classCallCheck2.default)(this, PagesForSitemapsAPI);
  }

  (0, _createClass2.default)(PagesForSitemapsAPI, null, [{
    key: "getIncludedPagesForSitemap",
    value: function getIncludedPagesForSitemap(_ref) {
      var domain = _ref.domain;
      return _apiClient.default.get(BASE_URL + "/included-pages", {
        query: {
          domain: domain
        }
      });
    }
  }, {
    key: "getExcludedPagesForSitemap",
    value: function getExcludedPagesForSitemap(_ref2) {
      var domain = _ref2.domain;
      return _apiClient.default.get(BASE_URL + "/excluded-pages", {
        query: {
          domain: domain
        }
      });
    }
  }]);
  return PagesForSitemapsAPI;
}();

exports.default = PagesForSitemapsAPI;
module.exports = exports.default;